import { useContext } from 'react';

import { OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionStateContext } from './OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionContextProvider';

import OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData from './OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData';

const useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData = () => {
  const [omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState, setOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState] = useContext(OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionStateContext);

  const getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection = (orgUnitAthleteEntryId, filterObj) =>
    OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData.getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData(orgUnitAthleteEntryId, JSON.stringify(filterObj), omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState, setOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState);

  const postOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection = (orgUnitAthleteEntryId, orgUnitNonAthleteEntryArray, credentialTypeId) =>
    OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData.postOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData(orgUnitAthleteEntryId, orgUnitNonAthleteEntryArray, credentialTypeId, omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState, setOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState);

  const clearOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionArrayData = () => {
    setOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState({
      ...omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: [],
      message: ''
    });
  };

  return {
    omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState,
    setOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState,
    getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection,
    postOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection,
    clearOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionArrayData
  };
};

export default useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData;